module.exports = __webpack_public_path__ + "static/media/videollamadaActivo.51140958.svg";